import React, { useState, useContext, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from '@material-ui/core/IconButton';
import { faCalculator } from '@fortawesome/free-solid-svg-icons';
import MainTable from '../../../components/tables/MainTable';
import ClientInfo from '../../recaudar/sections/ClientInfo';
import { InitCreditContext } from '../InitCreditContext';
import { refFormat } from '../../../helpers/tableFormatters';
import { currencyFormat } from '../../../helpers/tableFormatters';
import InitCreditClientModal from '../modals/InitCreditClientModal';
import { textFilter } from 'react-bootstrap-table2-filter';

const InitCreditClient = () => {
  const context = useContext(InitCreditContext);
  const { loading, client, clientCredits, loadClientCredits } = context;
  const [showRecaudoModal, setShowRecaudoModal] = useState();
  const [modalTitle, setModalTitle] = useState("");
  const [creditSelected, setCreditSelected] = useState();

  useEffect(() => {
    if (!creditSelected) return;
    setModalTitle("Recaudo Crédito")
  });

  const filtro = textFilter({
    style: {minWidth: '150px'},
    placeholder: 'Buscar'
  });

  const columns = [
    {
      dataField: 'prestamo',
      text: 'Nro.',
      headerClasses: 'border-0',
      align: 'left',
      classes: 'border-0 py-2 align-middle',
      sort: true,
      formatter: (dataField) => refFormat(dataField),
      filter: filtro
    },
    {
      dataField: 'credito',
      text: 'Nro. Crédito',
      headerClasses: 'border-0',
      classes: 'border-0 py-2 align-middle',
      sort: true,
      filter: filtro
    },
    {
      dataField: 'nombreTercero',
      text: 'Cliente',
      headerClasses: 'border-0',
      classes: 'border-0 py-2 align-middle',
      sort: true,
      filter: filtro
    },
    {
      dataField: 'nombrePagaduria',
      text: 'Pagaduría',
      headerClasses: 'border-0',
      classes: 'border-0 py-2 align-middle',
      sort: true,
      filter: filtro
    },
    {
      dataField: 'fechaCorte',
      text: 'Fecha Corte',
      headerClasses: 'border-0',
      classes: 'border-0 py-2 align-middle',
      sort: true,
      filter: filtro
    },
    {
      dataField: 'valorCuota',
      text: 'Valor Cuota',
      headerClasses: 'border-0 text-center',
      align: 'right',
      classes: 'border-0 py-2 align-middle',
      sort: true,
      formatter: (value) => currencyFormat(value),
      filter: filtro
    },
    {
      dataField: 'recaudado',
      text: 'Recaudado',
      headerClasses: 'border-0 text-center',
      align: 'right',
      classes: 'border-0 py-2 align-middle',
      sort: true,
      formatter: (value) => currencyFormat(value),
      filter: filtro
    },
    {
      dataField: '',
      headerClasses: 'border-0 text-center',
      headerStyle: {verticalAlign: 'top'},
      text: 'Acciones',
      classes: 'border-0 py-2',
      sort: false,
      formatter: (dataField, selected) => actionsFormatter(dataField, selected),
    },
  ];

  const actionsFormatter = (dataField, fieldSelected) => {
    if (!fieldSelected) return <></>
    const { inicializado } = fieldSelected;
    if(!inicializado){
      return (
        <div className='pl-4'>
          <IconButton
            onClick={() => handleCLickAction(fieldSelected)}
          >
            <FontAwesomeIcon
              style={{ width: '16px' }}
              icon={faCalculator}
              color="SteelBlue"
            />
          </IconButton>
        </div>
      )
    }

    return <></>

  }

  const handleCLickAction = data => {
    setCreditSelected(data);
    setShowRecaudoModal(true);
  }

  const onCloseModal = value => {
    if (value) loadClientCredits();
    setShowRecaudoModal(!showRecaudoModal);
    setCreditSelected(null);
  }
      
  return (
    <>
      <InitCreditClientModal
        open={showRecaudoModal} 
        data={creditSelected}
        toggle={onCloseModal} 
      />
      <ClientInfo context={InitCreditContext} />
      <MainTable
        title="Créditos Activos"
        data={clientCredits}
        columns={columns}
        keyField="id"
        className="px-2"
        loading={loading}
        noSearch
        noAdd
      />
    </>
  )
}

export default InitCreditClient